(function () {
    'use strict';

    angular.module('app.settings', [
        'app.core'
    ]);
})();
